import { Group } from '@mantine/core';
import { useFinancialsStore } from '../../../store/financials-store/financials-store';
import { setChart } from '../../../store/financials-store/financials-store.actions';
import { Charts as ViewableCharts } from '../../../store/financials-store/financials-store.type';
import { newCOLORS } from '../../../styles/colors';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';

function Tabs() {
  const selectedChart = useFinancialsStore((state) => state.chart);
  return (
    <Group>
      <ChartButton
        label="Cost vs Output"
        iconName="calendar_month"
        onClick={() => setChart(ViewableCharts.CostVersusOutput)}
        selected={selectedChart === ViewableCharts.CostVersusOutput}
      />
      <ChartButton
        label="Allocation of Costs"
        iconName="attach_money"
        onClick={() => setChart(ViewableCharts.AllocationOfCosts)}
        selected={selectedChart === ViewableCharts.AllocationOfCosts}
      />
      <ChartButton
        label="Cost by Initiative"
        iconName="task_alt"
        onClick={() => setChart(ViewableCharts.CostByInitiative)}
        selected={selectedChart === ViewableCharts.CostByInitiative}
      />
    </Group>
  );
}

function ChartButton({
  label,
  iconName,
  onClick,
  selected,
}: {
  label: string;
  iconName: string;
  onClick: () => void;
  selected: boolean;
}) {
  return (
    <Button
      variant={selected ? 'secondary' : 'outline'}
      radius="xl"
      size="sm"
      leftSection={
        <Icon
          name={iconName}
          color={selected ? newCOLORS.white : newCOLORS.gray}
          size={16}
          style={{ cursor: 'pointer' }}
        />
      }
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export { Tabs };
